var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Editor from "@monaco-editor/react";
import { omit } from "lodash";
import { twMerge } from "tailwind-merge";
/**
 * Creates and returns a Monoco Code Editor instance with JSON syntax highlighting.
 * For value, pass in a valid JSON string.
 *
 * @returns {React.FC} The rendered JSON Editor.
 */
export var JSONEditor = function (_a) {
    var _b = _a.readOnly, readOnly = _b === void 0 ? true : _b, options = _a.options, className = _a.className, props = __rest(_a, ["readOnly", "options", "className"]);
    return (React.createElement("div", { className: twMerge('!rounded-lg !overflow-hidden !min-w-20 !min-h-20', className) },
        React.createElement(Editor, __assign({}, omit(props, 'className', 'options'), { defaultLanguage: 'json', theme: 'vs-dark', options: __assign({ readOnly: readOnly, padding: { top: 16, bottom: 8 } }, options) }))));
};
